module.exports = __webpack_public_path__ + "img/background.8a66cc55.png";